module.exports = __webpack_public_path__ + "img/Tucana.ba81648d.png";